import { alarmsComponents } from "./alarmParameters/navigationComponents";

export const surveillanceComponents = [
	...alarmsComponents,
];
